<script setup lang="ts">
defineProps<{
  businessUnitCode: number;
  pathContext: string;
}>();

const { t } = useI18n();
</script>

<template>
  <!--  min-h-[30rem] to be able to see the full date picker dropdown even if there is no data in the table -->
  <div class="min-h-[30rem]">
    <h4 class="mb-5 text-gray-900">
      {{ t("administration.businessUnit.settings.logs.title") }}
    </h4>
    <log-list
      :business-unit-code="businessUnitCode"
      :path-context="pathContext"
    />
  </div>
</template>
